import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Divider,
  Paper,
  Typography,
  Container,
  withStyles,
  Box,
  Card,
  CardContent,
  FormControl,
  InputAdornment,
  SvgIcon,
} from "@material-ui/core";
import { Search as SearchIcon } from "react-feather";
import { NavLink as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { PatientActions } from "../../redux/actions/PatientActions";
import { DoctorAction } from "../../redux/actions/DoctorAction";
import PatienRecordList from "./PatienRecordList";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { USER_ROLE } from "../../components/security/UserRole";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Checkbox from "@material-ui/core/Checkbox";
import Fab from "@material-ui/core/Fab";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(3),
  },
  form: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class PatientList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doctorId: [],
      allPatientList: [],
      patientSearchList: [],
      isSearched: false,
    };
  }
  componentWillUnmount() {}
  componentDidMount() {
    this.props.getAllPatient();
    this.props.getAllDoctor();
  }

  getPatietnList() {
    return this.props.allPatientList;
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Patient</title>
        </Helmet>

        <Container component="main" fixed={false} className={classes.main}>
          <CssBaseline />

          <form
            className={classes.form}
            noValidate
            onSubmit={this.handleSubmit}
          >
            <Box display="flex" mb={1}>
              <Box flexGrow={1}>
                <Typography gutterBottom variant="h4" color="primary">
                  {"Patient Details"}
                </Typography>
              </Box>
              <Box>
                <Button
                  component={RouterLink}
                  variant="button"
                  variant="contained"
                  color="primary"
                  href="#contained-buttons"
                  to="/patient/add"
                >
                  Add new patient
                </Button>
              </Box>
            </Box>
            <Box display="flex" p={1} bgcolor="background.paper">
              <Box p={1} flexGrow={1}>
                <Autocomplete
                  multiple
                  value={this.state.doctorId}
                  id="checkboxes-tags-demo"
                  options={this.props.allDoctorList.map((option) => option)}
                  disableCloseOnSelect
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => {
                    return (
                      (option.firstName ? option.firstName : "") +
                      " " +
                      (option.lastName ? option.lastName : "")
                    );
                  }}
                  onChange={(event, newValue) => {
                    this.setState({ doctorId: newValue });
                    if (newValue && newValue.length > 0) {
                    } else {
                      this.setState({ isSearched: false });
                      this.props.clearSearch();
                    }
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {(option.firstName ? option.firstName : "") +
                        " " +
                        (option.lastName ? option.lastName : "")}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Doctor Name"
                      placeholder="Doctor Name"
                    />
                  )}
                />
              </Box>
              <Box style={{ margin: "auto" }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<SearchIcon />}
                  onClick={() => {
                    if (this.state.doctorId) {
                      this.setState({ isSearched: true });
                      let doctorList = this.state.doctorId.map((x) => x.id);
                      var payload = {
                        doctorList: doctorList,
                      };
                      if (
                        payload &&
                        payload.doctorList &&
                        payload.doctorList.length > 0
                      ) {
                        this.props.searchPatient(payload);
                      } else {
                        this.setState({ isSearched: false });
                        this.props.clearSearch();
                      }
                    }
                  }}
                >
                  Search
                </Button>
              </Box>
            </Box>
          </form>

          <PatienRecordList
            patientList={
              this.state.isSearched
                ? this.props.searchResult
                : this.props.allPatientList
            }
          ></PatienRecordList>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const userRole = state.authentication.user.userRole;
  const allPatientList = state.patient.all;
  const searchResult = state.patient.searchResult;
  const allDoctorList = state.doctor.allDoctorList;
  return { allPatientList, allDoctorList, userRole, searchResult };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllPatient: () => dispatch(PatientActions.getAllPatients()),
    searchPatient: (data) => dispatch(PatientActions.searchPatient(data)),
    clearSearch: () => dispatch(PatientActions.searchPatientSuccess([])),
    getAllDoctor: () => {
      dispatch(DoctorAction.getAllDoctors());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(PatientList));
